import LinkCard from './LinkCard';
import { LINKS } from '../constants';
import styles from './LinksSection.module.css';

export default function LinksSection({ accent }) {
  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <p className={styles.eyebrow} style={{ color: accent }}>
          Encuéntranos en
        </p>
        <h2 className={styles.title}>Nuestras plataformas</h2>
        <p className={styles.sub}>
          Todo lo que necesitas, en un solo lugar.
        </p>
      </div>

      <div className={styles.grid}>
        {LINKS.map((link) => (
          <LinkCard key={link.id} link={link} />
        ))}
      </div>
    </section>
  );
}
